import styled from 'styled-components';

export const ChannelCellStyled = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;
